var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.16 7.875H13.7586V3.5C13.7586 3.01875 13.3619 2.625 12.8772 2.625H9.35157C8.8668 2.625 8.47017 3.01875 8.47017 3.5V7.875H7.06875C6.28431 7.875 5.88768 8.82 6.44296 9.37125L10.4886 13.3875C10.8323 13.7288 11.3876 13.7288 11.7313 13.3875L15.777 9.37125C16.3323 8.82 15.9444 7.875 15.16 7.875ZM4.94458 16.625C4.94458 17.1062 5.34121 17.5 5.82598 17.5H16.4028C16.8875 17.5 17.2842 17.1062 17.2842 16.625C17.2842 16.1438 16.8875 15.75 16.4028 15.75H5.82598C5.34121 15.75 4.94458 16.1438 4.94458 16.625Z",
    fill: "#3783FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ddd818d42351cf5ddeaa0e5e5068bca2.svg";
export { ForwardRef as ReactComponent };